import { render, staticRenderFns } from "./BasicCard.vue?vue&type=template&id=3e972fde&scoped=true&"
import script from "./BasicCard.vue?vue&type=script&lang=js&"
export * from "./BasicCard.vue?vue&type=script&lang=js&"
import style0 from "./BasicCard.vue?vue&type=style&index=0&id=3e972fde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e972fde",
  null
  
)

export default component.exports